
import { IconComponents } from "components/Icon";
import "./components/MenuPhone.css";
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { RouterDOM } from "utilities/utilities";
import { IMenuItem } from "./components/MenuProps";
import { Link } from "react-router-dom";
import { ProviderLayout } from "./Homepage";

const MenuItemsPhone = (props: IMenuItem) => {
    const Router = RouterDOM();

    const {
        IsMenuOpen,
        IsOverMouse,
        handleClickMenuOpen
    } = useContext(ProviderLayout);

    const MenuSpace = () => {
        let nLevel = !IsMenuOpen && !IsOverMouse ? 1 : props.nLevel;
        return nLevel * 16 + "px";
    };

    const MenuActive = useCallback(() => {

        let sRouteCurrent = Router.GetCurrentRoute();
        let sRouteMenu = (props.sRoute ?? "").toLowerCase();
        return sRouteCurrent === sRouteMenu ? "active" : ""
    }, [window.location.href]);

    const handleScrollTo = (nMenuId) => {
        switch (nMenuId) {
            case 7:
                window.scrollTo({
                    top: 1000,
                    behavior: 'smooth'
                });
                break;
            case 8:
                window.scrollTo({
                    top: 1800,
                    behavior: 'smooth'
                });
                break;
            case 10:
                window.scrollTo({
                    top: 3400,
                    behavior: 'smooth'
                });
                break;
        }

    }



    return (
        <React.Fragment>
            {props.nMenuID === 7 || props.nMenuID === 8 || props.nMenuID === 10 ? (
                <>
                    <Tooltip title={props.sMenuName} placement="right">
                        <ListItem disablePadding>
                            <ListItemButton
                                key={props.nMenuID}
                                className={`nav-menu-itemPhone nav-menu-itemPhone-lv` + props.nLevel + " " + MenuActive()}
                                sx={{ pl: MenuSpace(), minWidth: '40px' }}
                                onClick={() => { handleScrollTo(props.nMenuID); }}
                            >
                                <ListItemIcon sx={{ ml: '2px' }}>
                                    {IconComponents(props.sIcon)}
                                </ListItemIcon>
                                <ListItemText primary={props.sMenuName} primaryTypographyProps={{ style: { whiteSpace: "nowrap", overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                            </ListItemButton>
                        </ListItem>
                    </Tooltip>
                </>
            ) : (
                <>
                    <Tooltip title={props.sMenuName} placement="right">
                        <Link
                            to={props.sRoute}
                            preventScrollReset={true}
                            style={{ textDecoration: 'none' }}
                        >
                            <ListItem disablePadding>
                                <ListItemButton
                                    key={props.nMenuID}
                                    className={`nav-menu-itemPhone nav-menu-itemPhone-lv` + props.nLevel + " " + MenuActive()}
                                    sx={{ pl: MenuSpace(), minWidth: '40px' }}
                                    onClick={() => { handleClickMenuOpen(props.nMenuID); Router.GoToPage(props.sRoute); }}
                                >
                                    <ListItemIcon sx={{ ml: '2px' }}>
                                        {IconComponents(props.sIcon)}
                                    </ListItemIcon>
                                    <ListItemText primary={props.sMenuName} primaryTypographyProps={{ style: { whiteSpace: "nowrap", overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                                </ListItemButton>
                            </ListItem>
                        </Link>
                    </Tooltip>
                </>
            )}
        </React.Fragment>
    )
}
export default MenuItemsPhone;
